/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProjectSprintsPredictionsQueryVariables = {|
  projectId?: ?string,
  groupId?: ?string,
|};
export type ProjectSprintsPredictionsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +component: ?string,
    +company: ?{|
      +availableMLModels: ?{|
        +lowHighModel: ?boolean,
        +lowHighModelScore: ?number,
      |}
    |},
    +predictionProject: ?{|
      +id: string,
      +predictedOverrunningTasks: ?$ReadOnlyArray<?{|
        +globalTaskId: ?string,
        +estimate: ?number,
        +overrunProbability: ?number,
      |}>,
    |},
    +predictionProjectGroup: ?{|
      +predictedOverrunningTasks: ?$ReadOnlyArray<?{|
        +globalTaskId: ?string,
        +estimate: ?number,
        +overrunProbability: ?number,
      |}>
    |},
  |}
|};
export type ProjectSprintsPredictionsQuery = {|
  variables: ProjectSprintsPredictionsQueryVariables,
  response: ProjectSprintsPredictionsQueryResponse,
|};
*/


/*
query ProjectSprintsPredictionsQuery(
  $projectId: ID
  $groupId: String
) {
  viewer {
    id
    component(name: "sprint_predictions")
    company {
      availableMLModels {
        lowHighModel
        lowHighModelScore
      }
      id
    }
    predictionProject: project(internalId: $projectId) {
      id
      predictedOverrunningTasks(approvedOnly: true) {
        globalTaskId
        estimate
        overrunProbability
      }
    }
    predictionProjectGroup: projectGroup(id: $groupId) {
      predictedOverrunningTasks(approvedOnly: true) {
        globalTaskId
        estimate
        overrunProbability
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId",
    "type": "String"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "sprint_predictions"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"sprint_predictions\")"
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AvailableMLModels",
  "kind": "LinkedField",
  "name": "availableMLModels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lowHighModel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lowHighModelScore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "approvedOnly",
      "value": true
    }
  ],
  "concreteType": "PredictedEstimate",
  "kind": "LinkedField",
  "name": "predictedOverrunningTasks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overrunProbability",
      "storageKey": null
    }
  ],
  "storageKey": "predictedOverrunningTasks(approvedOnly:true)"
},
v5 = {
  "alias": "predictionProject",
  "args": [
    {
      "kind": "Variable",
      "name": "internalId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "groupId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSprintsPredictionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": "predictionProjectGroup",
            "args": (v6/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectSprintsPredictionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": "predictionProjectGroup",
            "args": (v6/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ProjectSprintsPredictionsQuery",
    "operationKind": "query",
    "text": "query ProjectSprintsPredictionsQuery(\n  $projectId: ID\n  $groupId: String\n) {\n  viewer {\n    id\n    component(name: \"sprint_predictions\")\n    company {\n      availableMLModels {\n        lowHighModel\n        lowHighModelScore\n      }\n      id\n    }\n    predictionProject: project(internalId: $projectId) {\n      id\n      predictedOverrunningTasks(approvedOnly: true) {\n        globalTaskId\n        estimate\n        overrunProbability\n      }\n    }\n    predictionProjectGroup: projectGroup(id: $groupId) {\n      predictedOverrunningTasks(approvedOnly: true) {\n        globalTaskId\n        estimate\n        overrunProbability\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b0fbab93b4f9d54cef5a6e6f9b1ccd09';

module.exports = node;
